function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useLocation } from "@custom/schema";
import { format } from "date-fns";
import { de, enGB, fr, it } from "date-fns/locale";
import React, { createContext, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
export var defaultLocale = "en";
export function isLocale(input) {
  return Object.keys(locales).includes(input);
}
/**
 * Extract the current locale from the path prefix.
 */
export function useLocale() {
  var _useLocation = _sliced_to_array(useLocation(), 1),
    pathname = _useLocation[0].pathname;
  var prefix = pathname.split("/")[1];
  var subPrefix = pathname.split("/")[2];
  return isLocale(prefix) ? prefix : isLocale(subPrefix) ? subPrefix : defaultLocale;
}
/**
 * Select the most appropriate of localization from a list of options.
 */
export function useLocalized(options) {
  var locale = useLocale();
  return (options === null || options === void 0 ? void 0 : options.filter(function (option) {
    return (option === null || option === void 0 ? void 0 : option.locale) === locale;
  }).pop()) || (options === null || options === void 0 ? void 0 : options.filter(function (option) {
    return (option === null || option === void 0 ? void 0 : option.locale) === defaultLocale;
  }).pop());
}
export var locales = {
  en: {
    code: "en",
    flag: "\uD83C\uDDFA\uD83C\uDDF8",
    name: "English",
    hrefLang: "en-EN",
    dateLocale: enGB
  },
  de: {
    code: "de",
    flag: "\uD83C\uDDE9\uD83C\uDDEA",
    name: "Deutsch",
    hrefLang: "de-DE",
    dateLocale: de
  },
  fr: {
    code: "fr",
    flag: "\uD83C\uDDEB\uD83C\uDDF7",
    name: "Fran\xe7ais",
    hrefLang: "fr-FR",
    dateLocale: fr
  },
  it: {
    code: "it",
    flag: "\uD83C\uDDEE\uD83C\uDDF9",
    name: "Italiano",
    hrefLang: "it-IT",
    dateLocale: it
  }
};
export var LocalizationContext = /*#__PURE__*/createContext(undefined);
export var LocalizationProvider = function LocalizationProvider(param) {
  var locale = param.locale,
    defaultLocale = param.defaultLocale,
    children = param.children;
  var i18n = useTranslation().i18n;
  useEffect(function () {
    if (locale && i18n.language !== locale) {
      i18n.changeLanguage(locale);
    }
  }, [locale, i18n]);
  return /*#__PURE__*/React.createElement(LocalizationContext.Provider, {
    value: {
      defaultLocale: defaultLocale,
      locale: locale || defaultLocale,
      locales: locales,
      formatDate: formatLocalizedDate(locale || defaultLocale)
    }
  }, children);
};
export var useLocalization = function useLocalization() {
  var context = useContext(LocalizationContext);
  if (context === undefined) {
    throw new Error("useLocalization must be used within a LocalizationProvider");
  }
  return context;
};
export var formatLocalizedDate = function formatLocalizedDate(locale) {
  return function (date) {
    var dateFormat = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "PPP";
    return format(date, dateFormat, {
      locale: locales[locale].dateLocale
    });
  };
};